import { render, staticRenderFns } from "./ScoringDetail.vue?vue&type=template&id=408e9493&scoped=true&"
import script from "./ScoringDetail.vue?vue&type=script&lang=js&"
export * from "./ScoringDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScoringDetail.vue?vue&type=style&index=0&id=408e9493&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e9493",
  null
  
)

export default component.exports